import { combineReducers } from 'redux';
import update from 'immutability-helper';
import { reducer as birdChart } from './birdChart';
import { reducer as distribution } from './distribution';
import { reducer as alerts } from './alerts';
import { reducer as aiAlerts } from './aiAlerts';
import { reducer as tempDashboard } from './tempDashboard';
import { reducer as base } from './base';
import * as types from './types';
import { MODE_TRENDS } from './constants';

const initialState = {
  mode: MODE_TRENDS,
};

const switchMap = {
  [types.CHANGE_MODE]: (state, action) => {
    const { mode } = action;
    return update(state, {
      mode: {
        $set: mode,
      },
    });
  },
};

const meta = (state = initialState, action) => (
  switchMap[action.type]
    ? switchMap[action.type](state, action)
    : state
);

export default combineReducers({
  base,
  meta,
  birdChart,
  distribution,
  alerts,
  aiAlerts,
  tempDashboard,
});
